/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './chronic-condition.reducer';

export const ChronicConditionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const chronicConditionEntity = useAppSelector(state => state.chronicCondition.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="chronicConditionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.chronicCondition.detail.title">ChronicCondition</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.id">Id</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.id}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.category">Category</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.category}</dd>
          <dt>
            <span id="subCategory">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.subCategory">Sub Category</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.subCategory}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.active">Active</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.cursor}</dd>
          <dt>
            <span id="snomedConceptId">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.snomedConceptId">Snomed Concept Id</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.snomedConceptId}</dd>
          <dt>
            <span id="snomedConceptText">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.snomedConceptText">Snomed Concept Text</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.snomedConceptText}</dd>
          <dt>
            <span id="topographyStart">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.topographyStart">Topography Start</Translate>
            </span>
            <UncontrolledTooltip target="topographyStart">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.help.topographyStart" />
            </UncontrolledTooltip>
          </dt>
          <dd>{chronicConditionEntity.topographyStart}</dd>
          <dt>
            <span id="topographyEnd">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.topographyEnd">Topography End</Translate>
            </span>
            <UncontrolledTooltip target="topographyEnd">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.help.topographyEnd" />
            </UncontrolledTooltip>
          </dt>
          <dd>{chronicConditionEntity.topographyEnd}</dd>
          <dt>
            <span id="std">
              <Translate contentKey="tinyMedicRestApp.chronicCondition.std">Std</Translate>
            </span>
          </dt>
          <dd>{chronicConditionEntity.std ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.chronicCondition.diagnosis">Diagnosis</Translate>
          </dt>
          <dd>{chronicConditionEntity.diagnosis ? chronicConditionEntity.diagnosis.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.chronicCondition.topography">Topography</Translate>
          </dt>
          <dd>{chronicConditionEntity.topography ? chronicConditionEntity.topography.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.chronicCondition.morphologyGroup">Morphology Group</Translate>
          </dt>
          <dd>{chronicConditionEntity.morphologyGroup ? chronicConditionEntity.morphologyGroup.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.chronicCondition.morphology">Morphology</Translate>
          </dt>
          <dd>{chronicConditionEntity.morphology ? chronicConditionEntity.morphology.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.chronicCondition.behaviour">Behaviour</Translate>
          </dt>
          <dd>{chronicConditionEntity.behaviour ? chronicConditionEntity.behaviour.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/chronic-condition" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/chronic-condition/${chronicConditionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ChronicConditionDetail;
